<template>
  <div class="contianer">
    <div class="feedbackBox pc_container">
      <el-form
        :model="form"
        ref="formRef"
        width="auto"
        style="max-width: 600px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="姓名"
              prop="name"
              :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="form.name"
                placeholder="请输入姓名"
                clearable
                autofocus
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系方式"
              prop="phone"
              :rules="[
                {
                  required: true,
                  validator: checkPhone,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="form.phone"
                placeholder="请输入联系方式"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="留言内容"
          prop="content"
          :rules="[
            { required: true, validator: checkSpecialChar, trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="form.content"
            type="textarea"
            maxlength="255"
            :rows="10"
            placeholder="请输入留言内容"
            clearable
            resize="none"
            :show-word-limit="true"
          />
        </el-form-item>
        <div class="footer">
          <el-button @click="resetForm">重置</el-button>
          <el-button type="primary" :loading="loadding" @click="onSubmit">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
  
  <script>
export default {
  components: {},
  data() {
    return {
      form: {
        name: "",
        phone: "",
        content: "",
      },
      loadding : false
    };
  },
  created() {},
  methods: {
    resetForm() {
      this.$refs["formRef"].resetFields();
    },
    onSubmit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.loadding = true;
          this.$request({
            url: "feedBack",
            method: "post",
            data: this.form,
          }).then((res) => {
            this.loadding = false;
            if (res.code === 10000) {
              this.$message({
                message: '提交成功',
                type: "success",
                onClose: () =>{
                    this.resetForm();
                }
              })
             
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    checkPhone(rule, value, callback) {
      console.log(value);
      if (!value) {
        return callback(new Error("请输入联系方式"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的联系方式"));
        }
      }
    },
    
    checkSpecialChar(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入留言内容"));
      } else {
        //检测sql注入
        const reg = /select|update|delete|exec|count|'|"|=|;|>|<|%/i;
        if (reg.test(value)) {
          return callback(new Error("不能输入特殊字符"));
        } else {
          callback();
        }
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.contianer {
  background: #fff;
  .feedbackBox {
    padding: 30px  calc((1400px - 600px) / 2);
    box-sizing: border-box;
    .footer {
      display: flex;
      justify-content: end;
    }
  }
}
</style>
  